'use strict';

export default function PhysicianService($http, $cookies, $state) {
  'ngInject';

  let Physician = {
    getTimeoutData() {
      return $http.get('/api/schedules/schedulesData')
        .then((response) => {
          console.log('The schedule response fetched successfully');
          return response.data;
        })
        .catch(err => {
          console.log(err);    //view the err here
          console.log('Cannot fetch the schedules');
        });
    }
  }

  return Physician;

}



// WEBPACK FOOTER //
// ./client/app/physician/physician.service.js